import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Preweddingshootdestinationmorachi() {



    const cardData =
    {
        keyword: 'Pre-Wedding Shoot Destination Morachi Chincholi Pune',
        heading: 'Anand Krushi Paryatan Kendra: Pre-Wedding Shoot Destination Morachi Chincholi Pune',
        headingDescription: 'Searching for a peaceful and picturesque pre-wedding shoot destination Morachi Chincholi Pune? Look no further than Anand Krushi Paryatan Kendra, located just 55 km from Pune. Set across 40 acres of lush farmland, this agri-tourism gem offers a perfect blend of rustic village charm and natural beauty—making it an ideal setting for romantic, candid, and traditional pre-wedding photography. Couples can choose from a variety of scenic backdrops: green fields, traditional bullock carts, bamboo huts, rural water bodies, flower gardens, and more. The free-roaming peacocks and golden-hour lighting add a magical touch to every frame. It’s a favorite among photographers and couples seeking authentic and unique pre-wedding visuals.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',

topPlaces: [
  {
    "title": "Peacock Trails & Sunrise Fields",
    "description": "Start your day with soft golden light filtering through sugarcane fields where peacocks roam freely. Capture serene, magical moments as the morning mist hugs the landscape—ideal for candid nature shots."
  },
  {
    "title": "Rustic Bullock Cart & Tractor Props",
    "description": "Use colorfully decorated bullock carts or vintage-style tractors as backdrops for traditional couple portraits. These rural props add nostalgic charm and cultural warmth to your shoot."
  },
  {
    "title": "Flower Gardens & Orchard Walks",
    "description": "Stroll hand-in-hand through marigold gardens, mango orchards, or guava lanes. These vibrant, natural settings offer perfect frames for romantic, earthy couple photos."
  },
  {
    "title": "Traditional Village Setups",
    "description": "Pose in front of bamboo huts, mud walls, or old wooden doors decorated with rangoli and lanterns. Ideal for ethnic outfits and folk-themed pre-wedding stories."
  },
  {
    "title": "Pondside Reflections & Golden Hour",
    "description": "Use the still waters of the farm’s pond during golden hour to get dreamy reflection shots. The calm surroundings and soft lighting create a cinematic atmosphere."
  },
  {
    "title": "Swing & Hammock Frames",
    "description": "Shoot candid moments on traditional wooden swings or hammocks tied between trees. Surrounded by greenery and rustic décor, these settings bring relaxed intimacy into your frames."
  },
  {
    "title": "Evening Bonfire & Folk Backdrops",
    "description": "Capture warm, cozy scenes around a glowing bonfire. Add folk musicians, lanterns, or fairy lights to turn your sunset shoot into a romantic, starry-eyed memory."
  },
  {
    "title": "Rain Dance & Splash Pool Fun",
    "description": "Include fun, youthful vibes by dancing under rain showers or splashing in shallow pools. Perfect for lively, playful photo sequences with music and motion."
  },
  {
    "title": "Ethnic Props & Outfits",
    "description": "Make use of props like charpais, matkas, traditional turbans, or sarees for classic village-style visuals. Local staff often assist with setup to enhance the mood of the shoot."
  },
  {
    "title": "Stay & Shoot Packages",
    "description": "Book a full-day or overnight package that includes cottage stays, meals, access to exclusive photo spots, and assistance with location coordination—ideal for relaxed and versatile pre-wedding photography."
  }
],




  "services": [
    {
      "name": "Pre‑Wedding Shoot with Natural Backdrop",
      "description": "Capture your love amidst natural landscapes—lush farms, open fields, and golden hour skies. Ideal for couples seeking an authentic and serene outdoor photoshoot near Pune."
    },
    {
      "name": "Village‑Themed Photo Shoot Locations",
      "description": "Get that rustic charm with traditional village elements like mud walls, charpais, thatched roofs, and rural homes—perfect for an intimate, cultural pre‑wedding vibe."
    },
    {
      "name": "Scenic Shoot Spots Near Pune",
      "description": "Enjoy a variety of scenic backdrops—orchards, lakeside banks, hill edges, and open greenery—offering diverse settings for different moods in one photoshoot itinerary."
    },
    {
      "name": "Farms and Greenery for Pre‑Wedding Photos",
      "description": "Explore vibrant farms and manicured fields with daily farming activity—ideal for capturing candid moments and fresh, organic textures in your photos."
    },
    {
      "name": "Cultural Shoot Backdrops in Morachi Chincholi",
      "description": "Use local cultural elements—bullock carts, village folk art, traditional tools—to add depth and authenticity to your pre‑wedding frames."
    },
    {
      "name": "Rustic Outdoor Shoot Venues",
      "description": "Shoot against weathered wood fences, old barns, bamboo zones, and earthen pathways—great for couples wanting raw, textured, and earthy shots."
    },
    {
      "name": "Bullock Cart Photoshoot Setup",
      "description": "Make a statement with your shoot—pose on a decorated bullock cart surrounded by farms and open skies for a truly memorable pre‑wedding photo."
    },
    {
      "name": "Nature Trails for Couple Shoots",
      "description": "Walk through winding trails lined with trees, flowers, and sunlight filtering through foliage—ideal for capturing candid, romantic moments in motion."
    },
    {
      "name": "Affordable Pre‑Wedding Packages",
      "description": "Choose from cost‑effective shoot packages that include location access, décor setup, guide assistance, and optional local styling, all tailored to fit your budget."
    },
    {
      "name": "Local Costume Rental for Traditional Shoots",
      "description": "Enhance your shoot with traditional Maharashtrian attire—paithani sarees, pheta, jewelry—from local wardrobe rentals to give an authentic regional look."
    },
    {
      "name": "Floral and Rural Décor Options",
      "description": "Choose custom décor like flower arches, marigold strings, rustic props, hay bales, and lanterns to complement your rural setting and add elegance to the shoot."
    },
    {
      "name": "Romantic Photoshoot Places Near Pune",
      "description": "From sunrise dew to sunset hues—select spots that offer privacy, romance, and natural beauty for intimate couple portraits."
    },
    {
      "name": "Farm Stay + Photoshoot Combos",
      "description": "Combine a pre‑wedding shoot with an overnight stay in a cozy farmhouse—rest, styling, and fresh farm meals included for a relaxed shoot experience."
    },
    {
      "name": "Eco‑Friendly Photoshoot Spots",
      "description": "Opt for green, sustainable shoot locations that respect the environment—no plastic décor, natural lighting, and biodegradable props."
    },
    {
      "name": "Seasonal Bloom Shoot Locations",
      "description": "Capture the magic of seasonal flowers—from mustard yellow fields to wildflower patches and mango blossoms—for vibrant, colorful pre‑wedding images."
    }
  ],
  "tableData": [
    ["Pre‑Wedding Shoot with Natural Backdrop", "Village‑Themed Photo Shoot Locations"],
    ["Scenic Shoot Spots Near Pune", "Farms and Greenery for Pre‑Wedding Photos"],
    ["Cultural Shoot Backdrops in Morachi Chincholi", "Rustic Outdoor Shoot Venues"],
    ["Bullock Cart Photoshoot Setup", "Nature Trails for Couple Shoots"],
    ["Affordable Pre‑Wedding Packages", "Local Costume Rental for Traditional Shoots"],
    ["Floral and Rural Décor Options", "Romantic Photoshoot Places Near Pune"],
    ["Farm Stay + Photoshoot Combos", "Eco‑Friendly Photoshoot Spots"],
    ["Seasonal Bloom Shoot Locations", ""]
  ],



"whychoose": [
  {
    "WhyChooseheading": "Scenic Natural Backdrops",
    "WhyChoosedescription": "Morachi Chincholi offers beautiful rural landscapes with sprawling tamarind groves, green farms, lotus ponds, and open skies—perfect for romantic and timeless pre-wedding shoot settings. The serene environment adds charm and elegance to every captured moment."
  },
  {
    "WhyChooseheading": "Peacocks and Wildlife in Frame",
    "WhyChoosedescription": "As a village known for its peacock sanctuary, couples can enjoy stunning shots with free-roaming peacocks in the background, adding a unique and regal element to their pre-wedding memories."
  },
  {
    "WhyChooseheading": "Rustic Village Ambiance",
    "WhyChoosedescription": "Capture your love story in an authentic Maharashtrian rural setting with elements like bullock carts, tractors, traditional huts, and scenic farms. This rustic charm creates a storytelling vibe ideal for candid and cultural photoshoots."
  },
  {
    "WhyChooseheading": "Ample Space and Privacy",
    "WhyChoosedescription": "With large open areas and less crowd than urban parks, Morachi Chincholi offers couples complete privacy and flexibility for creative shots without interruptions. Ideal for both casual and cinematic photography."
  },
  {
    "WhyChooseheading": "Close Proximity to Pune",
    "WhyChoosedescription": "Located just 55–60 km from Pune, Morachi Chincholi is perfect for a one-day pre-wedding shoot. The easy travel access allows couples and their crew to conduct shoots efficiently without long travel times."
  },
  {
    "WhyChooseheading": "Supportive Agro-Tourism Resorts",
    "WhyChoosedescription": "Venues like Anand Krushi Paryatan Kendra and Mauli Krushi Paryatan offer support for pre-wedding shoots including changing rooms, resting areas, and food arrangements—making the experience smooth and enjoyable."
  }
]






























    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'Is Morachi Chincholi a good location for a pre-wedding shoot near Pune?',
    answer: 'Yes, Morachi Chincholi is an excellent choice for a pre-wedding shoot with its natural beauty, open farms, rustic charm, and scenic peacock zones.',
  },
  {
    id: 'FAQ2',
    question: 'What are the best spots for pre-wedding photography in Morachi Chincholi?',
    answer: 'Top spots include lush green farms, peacock areas, mud houses, bullock carts, traditional village lanes, and butterfly gardens.',
  },
  {
    id: 'FAQ3',
    question: 'Do we need prior permission for a pre-wedding shoot?',
    answer: 'Yes, it is advised to take permission from the resort or farmhouse where you plan to shoot, especially for professional setups or drone usage.',
  },
  {
    id: 'FAQ4',
    question: 'Can we stay overnight during our shoot?',
    answer: 'Yes, many resorts and farmhouses offer overnight stays with meals, which is convenient for early morning or multi-day shoots.',
  },
  {
    id: 'FAQ5',
    question: 'Are changing rooms or private spaces available during the shoot?',
    answer: 'Most locations offer basic changing rooms or private cottages that can be used to change outfits during the shoot.',
  },
  {
    id: 'FAQ6',
    question: 'Is Morachi Chincholi suitable for both traditional and modern shoot themes?',
    answer: 'Absolutely. The village atmosphere blends beautifully with both ethnic attire and contemporary photo concepts.',
  },
  {
    id: 'FAQ7',
    question: 'What is the ideal time to plan a pre-wedding shoot here?',
    answer: 'The best time is from October to February, when the weather is pleasant and the scenery is vibrant and green.',
  },
  {
    id: 'FAQ8',
    question: 'Is the location crowded on weekends?',
    answer: 'Weekends can be moderately busy, so early morning or weekday shoots are recommended for peaceful sessions.',
  },
  {
    id: 'FAQ9',
    question: 'How far is Morachi Chincholi from Pune?',
    answer: 'It is located around 60–65 km from Pune and takes about 1.5 to 2 hours by road.',
  },
  {
    id: 'FAQ10',
    question: 'Can local photographers be arranged at the location?',
    answer: 'Yes, some resorts collaborate with experienced local photographers or can assist in arranging one for your shoot.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Saurabh Jagtap, Pune',
    feedback: "We had our pre-wedding shoot at Morachi Chincholi and the rustic beauty made every shot look magical. Highly recommended!",
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Tanvi Mahajan, Navi Mumbai',
    feedback: "Beautiful place for pre-wedding photos! The green fields, vintage backdrops, and calm environment gave us stunning memories.",
    rating: 5,
  },
];
































    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pre-Wedding Shoot Destination Morachi Chincholi Pune",
  "description": "Capture your pre-wedding moments at scenic Morachi Chincholi with natural backdrops, village-themed locations, rustic outdoor venues, bullock cart setups, and eco-friendly shoots. Affordable packages with cultural costumes and farm stay combos available.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Anand Krushi Paryatan Kendra",
    "sameAs": "https://morachichincholi.in/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Morachi Chincholi, Pune"
  },
  "serviceType": "Pre-wedding photoshoot",
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "15000",
    "availability": "https://schema.org/InStock",
    "url": "https://morachichincholi.in/pre-wedding-shoot"
  }
};



    return (
        <div>
<Helmet>
  <title>Pre-Wedding Shoot Destination Morachi Chincholi Pune | Scenic & Rustic Outdoor Photoshoots</title>
  <meta 
    name="description" 
    content="Plan your pre-wedding shoot at Morachi Chincholi near Pune. Enjoy village-themed locations, rustic outdoor venues, bullock cart setups, natural scenic spots, affordable packages, and cultural costume rentals." 
  />
  <meta 
    name="keywords" 
    content="Pre-wedding shoot with natural backdrop, Village-themed photo shoot locations, Scenic shoot spots near Pune, Farms and greenery for pre-wedding photos, Cultural shoot backdrops in Morachi Chincholi, Rustic outdoor shoot venues, Bullock cart photoshoot setup, Nature trails for couple shoots, Affordable pre-wedding packages, Local costume rental for traditional shoots, Floral and rural décor options, Romantic photoshoot places near Pune, Farm stay + photoshoot combos, Eco-friendly photoshoot spots, Seasonal bloom shoot locations" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/37.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Preweddingshootdestinationmorachi;